// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"44778292","455":"7b119b98","628":"d1b5bd7a"}[chunkId] + ".chunk.js";
};